export const FLOWPLAYER_FLOW_DATA_FETCH = 'FLOWPLAYER_FLOW_DATA_FETCH'
export const FLOWPLAYER_FLOW_DATA_FETCH_REQUEST = 'FLOWPLAYER_FLOW_DATA_FETCH_REQUEST'
export const FLOWPLAYER_FLOW_DATA_FETCH_RESPONSE = 'FLOWPLAYER_FLOW_DATA_FETCH_RESPONSE'
export const FLOWPLAYER_FLOW_DATA_FETCH_ERROR = 'FLOWPLAYER_FLOW_DATA_FETCH_ERROR'
